import React from "react";
import CompanyList from "./component/CompanyList";

const Company = () => {
  return (
    <div>
      <CompanyList />
    </div>
  );
};

export default Company;
